import React, { useEffect, useState } from "react";
import { CardText, Row, Col, Modal, ModalBody } from "reactstrap";
import "assets/scss/website/app.scss";
import Select from "react-select";
import "react-rangeslider/lib/index.css";
import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import "react-multi-carousel/lib/styles.css";
import { useSelector, useDispatch } from "react-redux";
import { appendFilters, resetFilters } from "store/filter/actions";
import "./styles.scss";
import HomeService from "services/Website/HomeService";
import { SuccessOk } from "configs/statusCode";
import { useTranslation } from "react-i18next";
import { paymentOptions } from "Enums/fixedData";
import AreaService from "services/Website/AreaServic";
import CompoundService from "services/Website/CompoundService";
import RoomFilter from "./RoomFilter";
import filterIcon from "../../../assets/images/filter.svg";

const SideFilters = ({ id, type, setLoading, loading, modal, setModal }) => {
	const filterData = useSelector((state) => state.filter);
	const AuthData = useSelector((state) => state.Auth);
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const compoundService = new CompoundService();

	const showLoading = () => setLoading(true);

	// useEffect(()=>{
	//   compoundService?.getCompoundSpecifications(id).then(response=>{
	//     if (response && response.status === SuccessOk) {
	//       dispatch(appendFilters({
	//         // budgetRange: [!!response.data.minBudget ? parseInt(response.data.minBudget) : 0, !!response.data.maxBudget ? parseInt(response.data.maxBudget) : 1],
	//         // budget: [!!response.data.minBudget ? parseInt(response.data.minBudget) : 0, !!response.data.maxBudget ? parseInt(response.data.maxBudget) : 1],
	//         budgetRange: (response.data.minBudget == response.data.maxBudget || !response.data.minBudget) ? [1, response.data.maxBudget] : [response.data.minBudget, response.data.maxBudget],
	//         budget: (response.data.minBudget == response.data.maxBudget || !response.data.minBudget) ? [1, response.data.maxBudget] : [response.data.minBudget, response.data.maxBudget],
	//         sizeRange: (response.data.minSize == response.data.maxSize || !response.data.minSize) ? [1, parseFloat(response.data.maxSize)] : [parseFloat(response.data.minSize), parseFloat(response.data.maxSize)],
	//         size: (response.data.minSize == response.data.maxSize || !response.data.minSize) ? [1, parseFloat(response.data.maxSize)] : [parseFloat(response.data.minSize), parseFloat(response.data.maxSize)],
	//         // size: [!!response.data.minSize ? parseInt(response.data.minSize) : 0, !!response.data.maxSize ? parseInt(response.data.maxSize) : 1],
	//         bathroomsRange: parseInt(response.data.minBathrooms) !== parseInt(response.data.maxBathrooms) ? [parseInt(response.data.minBathrooms) , parseInt(response.data.maxBathrooms) ] : [parseInt(response.data.minBathrooms)],
	//         bedroomsRange: parseInt(response.data.minBedrooms) !== parseInt(response.data.maxBedrooms) ? [parseInt(response.data.minBedrooms) , parseInt(response.data.maxBedrooms) ] : [parseInt(response.data.minBedrooms)],
	//         floorRange: parseInt(response.data.minFloor) !== parseInt(response.data.maxFloor) ? [parseInt(response.data.minFloor) , parseInt(response.data.maxFloor) ] : [parseInt(response.data.minFloor)],
	//         CategortiesOptions: response.data.categories?.map(type=>{
	//           return{
	//             name: type?.name,
	//             value: type?.id,
	//             label: type?.name[AuthData?.lang]
	//           }
	//         }) ,
	//         finishingOptions: response.data.finishing_types ,
	//         unitTypeOptions: response.data.unit_types?.map(type=>{
	//           return{
	//             name: type?.name,
	//             value: type?.id,
	//             label: type?.name[AuthData?.lang]
	//           }
	//         }) ,
	//         getRanges:true,
	//       }))
	//       showLoading()
	//     }
	//   })
	// },[id])

	const onSlide = (...rest) => {
		dispatch(appendFilters({ budget: rest[0] }));
		showLoading();
	};

	const onSlideSize = (...rest) => {
		dispatch(appendFilters({ size: rest[2] }));
		showLoading();
	};

	return (
		<Modal
			isOpen={modal}
			toggle={() => setModal(false)}
			className="sideFilters custom-filter">
			<div className="position-relative">
				<div className="title">
					<div className="d-flex" style={{ gap: "8px" }}>
						<img src={filterIcon} alt="filterIcon" />
						<span className="gotham-font">Filter By</span>
					</div>
					<i
						className="fa fa-times cursor-pointer"
						onClick={() => setModal(false)}
					/>
				</div>
				{loading ? (
					<div
						style={{
							opacity: ".6",
							zIndex: 300,
							position: "absolute",
							width: "100%",
							height: "100%",
							top: 0,
							left: 0,
						}}></div>
				) : null}

				<AvForm>
					<label className="fw-bold">{t("property type")}</label>
					<div className="d-grid" style={{ gridTemplateColumns: "auto auto" }}>
						{filterData?.unitTypeOptions?.map((type, index) => {
							return (
								<label className="select" key={index}>
									<input
										type="checkbox"
										name="UnitType"
										id={`btncheckType${index}`}
										autoComplete="off"
										checked={filterData?.unitType?.some(
											(item) => item?.name?.en === type?.name?.en
										)}
										onChange={() => {
											const isExist = filterData?.unitType?.some(
												(item) => item?.name?.en === type?.name?.en
											);
											if (!isExist) {
												dispatch(
													appendFilters({
														unitType: [...filterData.unitType, type],
													})
												);
											} else {
												const updatedData = filterData?.unitType?.filter(
													(item) => item?.name?.en !== type?.name?.en
												);
												dispatch(appendFilters({ unitType: [...updatedData] }));
											}
											showLoading();
										}}
									/>
									{type?.name?.en}
								</label>
							);
						})}
					</div>

					<label className="fw-bold mt-4">{t("finishing")}</label>
					<div className="d-grid" style={{ gridTemplateColumns: "auto auto" }}>
						{filterData?.finishingOptions?.map((type, index) => {
							return (
								<label
									className="select"
									key={index}
									onClick={() => {
										const isExist = filterData?.finishingType?.some(
											(item) => item?.name?.en === type?.name?.en
										);
										if (!isExist) {
											dispatch(
												appendFilters({
													finishingType: [...filterData.finishingType, type],
												})
											);
											showLoading();
										} else {
											const updatedData = filterData?.finishingType?.filter(
												(item) => item?.name?.en !== type?.name?.en
											);
											dispatch(
												appendFilters({ finishingType: [...updatedData] })
											);
											showLoading();
										}
									}}>
									<input
										type="checkbox"
										name="typeFinish"
										id={`typeFinish${index + 1}`}
										autoComplete="off"
										checked={filterData?.finishingType?.some(
											(item) => item?.name?.en === type?.name?.en
										)}
										onChange={() => {}}
									/>
									{type?.name?.en}
								</label>
							);
						})}
					</div>

					<label className="fw-bold mt-4">{t("Categories")}</label>
					<div className="d-grid" style={{ gridTemplateColumns: "auto auto" }}>
						{filterData.CategortiesOptions.map((type, index) => {
							return (
								<label
									key={index}
									onClick={() => {
										const isExist = filterData.categories_ids.some(
											(item) => item?.name?.en === type?.name?.en
										);
										if (!isExist) {
											dispatch(
												appendFilters({
													categories_ids: [...filterData.categories_ids, type],
												})
											);
											showLoading();
										} else {
											const updatedData = filterData.categories_ids.filter(
												(item) => item?.name?.en !== type?.name?.en
											);
											dispatch(
												appendFilters({ categories_ids: [...updatedData] })
											);
											showLoading();
										}
									}}>
									<input
										type="checkbox"
										className="btn-check"
										name="typeCatogory"
										id={`typeCatogory${index}`}
										autoComplete="off"
										onChange={() => {}}
										checked={filterData.categories_ids.some(
											(item) => item?.name?.en === type?.name?.en
										)}
									/>
									{type?.name?.en}
								</label>
							);
						})}
					</div>

					<label className="fw-bold mt-4">{t("Floor")}</label>
					<div className="d-block btn-group-toggle" data-toggle="buttons">
						<RoomFilter
							roomsType={"floorRange"}
							value={"floor"}
							showLoading={showLoading}
						/>
					</div>

					<label className="fw-bold mt-4">{t("Bedrooms")}</label>
					<div className="d-block btn-group-toggle" data-toggle="buttons">
						<RoomFilter
							roomsType={"bedroomsRange"}
							value={"bedrooms"}
							showLoading={showLoading}
						/>
					</div>

					<label className="fw-bold mt-4">{t("Bathrooms")}</label>
					<div className="d-block btn-group-toggle" data-toggle="buttons">
						<RoomFilter
							roomsType={"bathroomsRange"}
							value={"bathrooms"}
							showLoading={showLoading}
						/>
					</div>

					{!!filterData.size && (
						<div className="mt-5">
							<label className="fw-bold">
								{t("Square Meter")} ({t("M2")})
							</label>
							<Row>
								<Col md={6}>
									<AvField
										name="square"
										type="number"
										min="1"
										placeholder={t("Min")}
										className="fotm-control btnHeight mb-2"
										value={Math.round(filterData.size[0])}
										onChange={(e) => {
											dispatch(
												appendFilters({
													size: [Number(e.target.value), filterData.size[1]],
												})
											);
										}}
									/>
								</Col>
								<Col md={6}>
									<AvField
										name="square"
										type="number"
										min="1"
										placeholder={t("Max")}
										className="fotm-control btnHeight mb-2"
										value={filterData.size[1]}
										onChange={(e) => {
											dispatch(
												appendFilters({
													size: [filterData.size[0], Number(e.target.value)],
												})
											);
										}}
									/>
								</Col>
							</Row>
							{/* {AuthData.lang === "ar" ? (
								<Nouislider
									range={{
										min: filterData.sizeRange[0],
										max: filterData.sizeRange[1],
									}}
									tooltips={false}
									step={10}
									start={filterData.size}
									connect
									onSlide={onSlideSize}
									direction={"rtl"}
								/>
							) : null}
							{AuthData.lang !== "ar" ? (
								<Nouislider
									range={{
										min: filterData.sizeRange[0],
										max: filterData.sizeRange[1],
									}}
									tooltips={false}
									step={10}
									start={filterData.size}
									connect
									onSlide={onSlideSize}
									direction={"ltr"}
								/>
							) : null} */}
						</div>
					)}
					{!!filterData.size && <hr />}
					{!!filterData.budget && (
						<div className="mt-4">
							<label className="fw-bold">{t("Price Range")}</label>
							<Row>
								<Col md={6}>
									<AvField
										name="budget"
										type="number"
										min="1"
										placeholder={t("Min")}
										className="fotm-control btnHeight mb-2"
										value={filterData.budget[0]}
										onChange={(e) => {
											dispatch(
												appendFilters({
													budget: [
														Number(e.target.value),
														filterData.budget[1],
													],
												})
											);
										}}
									/>
								</Col>
								<Col md={6}>
									<AvField
										name="budget"
										type="number"
										min="1"
										placeholder={t("Max")}
										className="fotm-control btnHeight mb-2"
										value={filterData.budget[1]}
										onChange={(e) => {
											dispatch(
												appendFilters({
													budget: [
														filterData.budget[0],
														Number(e.target.value),
													],
												})
											);
										}}
									/>
								</Col>
							</Row>
							{/* {AuthData.lang === "ar" ? (
								<Nouislider
									range={{
										min: filterData.budgetRange[0],
										max: filterData.budgetRange[1],
									}}
									step={5000}
									tooltips={false}
									start={filterData.budget}
									connect
									onSlide={onSlide}
									direction={"rtl"}
								/>
							) : null}
							{AuthData.lang !== "ar" ? (
								<Nouislider
									range={{
										min: filterData.budgetRange[0],
										max: filterData.budgetRange[1],
									}}
									step={5000}
									tooltips={false}
									start={filterData.budget}
									connect
									onSlide={onSlide}
									direction={"ltr"}
								/>
							) : null} */}
						</div>
					)}
					{!!filterData.budget && <hr />}
					{type === "Unit" && (
						<div>
							<label className="fw-bold">{t("Unit Code")}</label>
							<AvField
								id={"propertyNamme"}
								name="Unit Code"
								placeholder={t("Unit Code")}
								className="fotm-control btnHeight mb-2"
								value={filterData.unit}
								onChange={(e) => {
									dispatch(appendFilters({ unit: e.target.value }));
								}}
							/>
						</div>
					)}
					<br />

					<div className="d-flex flex-row-reverse">
						<button
							className="btn shadow-none rest-Btn font-size-14 text-dark px-0 "
							type="button"
							onClick={() => {
								dispatch(resetFilters());
								showLoading();
							}}>
							{t("reset all")}
						</button>
					</div>
				</AvForm>
			</div>
		</Modal>
	);
};

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};
const getFixed = (number) => number.toFixed(0);

export default SideFilters;
